export default {
  root: {
    height: 80,
  },
};
